export default function HousingCompanyInfoCard({ companyInfo }) {
  const infoSections = companyInfo
    ? [
        {
          title: "Perustiedot",
          lines: [
            `Osoite: ${companyInfo.address}`,
            `Postitoimipaikka: ${companyInfo.postal_city}`,
            `Postinumero: ${companyInfo.postal_code}`,
          ],
        },
        {
          title: "Isännöinti",
          lines: [
            `Isännöitsijä yhtiö: ${companyInfo.property_management}`,
            `Isännöitsijä: ${companyInfo.roles?.property_manager?.name || "Jane Doe"}`,
            companyInfo.roles?.property_manager?.email || "janedoe@gmail.com",
          ],
        },
        {
          title: "Puheenjohtaja",
          lines: [
            companyInfo.roles?.chairman?.name || "John Doe",
            companyInfo.roles?.chairman?.email || "johndoe@gmail.com",
          ],
        },
        {
          title: "Projektipäällikkö",
          lines: [
            companyInfo.roles?.project_manager?.name || "Jason Doe",
            companyInfo.roles?.project_manager?.email || "jasondoe@gmail.com",
          ],
        },
        {
          title: "Suunnittelija",
          lines: [
            companyInfo.roles?.designer?.name || "Jasmine Doe",
            companyInfo.roles?.designer?.email || "jasminedoe@gmail.com",
          ],
        },
      ]
    : [];

  return (
    <div className="housing-company-info-container card-box">
      <p className="category-title">Taloyhtiön tiedot</p>

      {companyInfo ? (
        <div className="default-text">
          <p><strong>{companyInfo.company_name}</strong></p>

          <div className="company-info-grid">
            {infoSections.map((section) => (
              <div className="company-info-block" key={section.title}>
                <p className="company-info-block-title">{section.title}</p>
                {section.lines.map((line) => (
                  <p key={line}>{line}</p>
                ))}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <p>Ladataan taloyhtiön tietoja...</p>
      )}
    </div>
  );
}